<template>
  <div class="round-button__container">
    <button
      type="button"
      :class="['round-button__button', size]"
      :disabled="disabled"
      :data-test-id="testId"
      @click="handleClick"
    >
      <md-icon
        class="round-button__button-icon"
        :md-src="iconSrc"
        :data-test-id="`${testId}-icon`"
      >
        {{ !iconSrc && icon }}
      </md-icon>
    </button>
    <span
      v-if="label"
      class="round-button__label"
      :data-test-id="`${testId}-label`"
    >
      {{ label }}
    </span>
  </div>
</template>

<script>
import UiMixin from '@com/mixins/ui.mixin'

export default {
  name: 'round-button',
  mixins: [UiMixin],
  props: {
    icon: { type: String, default: '' },
    label: { type: String, default: '' },
    testId: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    size: { type: String, default: 'md' }
  },
  computed: {
    iconSrc () {
      return this.icon.includes('.svg') ? this.icon : null
    }
  },
  methods: {
    handleClick (e) {
      // Ripple эффект
      this.addRippleOnBtnClick(e)

      // Передаём событие наружу
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss">
@import '~scss/variables';

.round-button {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: max-content;
  }

  &__button {
    position: relative;
    overflow: hidden;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: $color-graphite;
    border: none;
    cursor: pointer;
    padding: 12px;
    transition: background 0.3s;

    &.sm {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;

      i.md-icon {
        margin: 0;
        min-width: 16px;
        width: 16px;
        height: 16px;
        font-size: 16px !important;
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &-icon {
      &.md-icon {
        color: $color-mint !important;
      }
    }

   .ripple {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.5);
      transform: scale(0);
      animation: ripple-animation 0.6s linear;
      pointer-events: none;
      z-index: 1;
    }
  }

  &__label {
    margin-top: 10px;
    font-size: 1rem;
    line-height: 1;
    font-weight: 400;
    text-align: center;
  }
}

@keyframes ripple-animation {
  to {
    transform: scale(4);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/common/UI/RoundBtn.vue